"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditClaimedCertificationDtoCodeEnum = void 0;
exports.instanceOfDocumentAuditClaimedCertificationDto = instanceOfDocumentAuditClaimedCertificationDto;
exports.DocumentAuditClaimedCertificationDtoFromJSON = DocumentAuditClaimedCertificationDtoFromJSON;
exports.DocumentAuditClaimedCertificationDtoFromJSONTyped = DocumentAuditClaimedCertificationDtoFromJSONTyped;
exports.DocumentAuditClaimedCertificationDtoToJSON = DocumentAuditClaimedCertificationDtoToJSON;
exports.DocumentAuditClaimedCertificationDtoToJSONTyped = DocumentAuditClaimedCertificationDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditClaimedCertificationDtoCodeEnum = {
    AGnp: 'A_GNP',
    Aacrn: 'AACRN',
    AccnsAg: 'ACCNS_AG',
    AccnsN: 'ACCNS_N',
    AccnsP: 'ACCNS_P',
    Achpn: 'ACHPN',
    Acls: 'ACLS',
    AcnpBc: 'ACNP_BC',
    Acnpc: 'ACNPC',
    AcnpcAg: 'ACNPC_AG',
    AcnsBc: 'ACNS_BC',
    Acrn: 'ACRN',
    AdmBc: 'ADM_BC',
    AeC: 'AE_C',
    AfnBc: 'AFN_BC',
    AgacnpBc: 'AGACNP_BC',
    AgcnsBc: 'AGCNS_BC',
    AgnBc: 'AGN_BC',
    AgpcnpBc: 'AGPCNP_BC',
    AhnBc: 'AHN_BC',
    AnpBc: 'ANP_BC',
    Aocn: 'AOCN',
    Aocnp: 'AOCNP',
    Aocns: 'AOCNS',
    AphnBc: 'APHN_BC',
    Apls: 'APLS',
    BcAdm: 'BC_ADM',
    Bls: 'BLS',
    Bmtcn: 'BMTCN',
    CEfm: 'C_EFM',
    CNpt: 'C_NPT',
    Cals: 'CALS',
    Cans: 'CANS',
    Capa: 'CAPA',
    Carn: 'CARN',
    CarnAp: 'CARN_AP',
    Cbcn: 'CBCN',
    Cbhc: 'CBHC',
    Cccn: 'CCCN',
    CccnAp: 'CCCN_AP',
    CchpA: 'CCHP_A',
    CchpRn: 'CCHP_RN',
    Ccht: 'CCHT',
    Cchta: 'CCHTA',
    Ccns: 'CCNS',
    Ccra: 'CCRA',
    Ccrc: 'CCRC',
    Ccrn: 'CCRN',
    CcrnE: 'CCRN_E',
    CcrnK: 'CCRN_K',
    Ccrp: 'CCRP',
    Cctm: 'CCTM',
    CdLpn: 'CD_LPN',
    CdLvn: 'CD_LVN',
    Cde: 'CDE',
    Cdn: 'CDN',
    Cen: 'CEN',
    Cenp: 'CENP',
    Cfcn: 'CFCN',
    Cfrn: 'CFRN',
    Cgrn: 'CGRN',
    Chfn: 'CHFN',
    ChfnK: 'CHFN_K',
    Chpca: 'CHPCA',
    Chpln: 'CHPLN',
    Chpn: 'CHPN',
    Chpna: 'CHPNA',
    Chppn: 'CHPPN',
    Chsa: 'CHSA',
    Cic: 'CIC',
    Cm: 'CM',
    Cmc: 'CMC',
    Cmcn: 'CMCN',
    Cmsrn: 'CMSRN',
    Cne: 'CNE',
    Cnl: 'CNL',
    Cnml: 'CNML',
    Cnn: 'CNN',
    CnnM: 'CNN_M',
    CnnNp: 'CNN_NP',
    Cnor: 'CNOR',
    Cnrn: 'CNRN',
    CnsBc: 'CNS_BC',
    CnsCp: 'CNS_CP',
    Cocn: 'COCN',
    CocnAp: 'COCN_AP',
    Cohn: 'COHN',
    CohnS: 'COHN_S',
    Corln: 'CORLN',
    Cpan: 'CPAN',
    Cpen: 'CPEN',
    Cphon: 'CPHON',
    Cphq: 'CPHQ',
    Cphrm: 'CPHRM',
    Cplc: 'CPLC',
    Cpn: 'CPN',
    CpnpPc: 'CPNP_PC',
    Cpon: 'CPON',
    CppAc: 'CPP_AC',
    Cpsn: 'CPSN',
    Crn: 'CRN',
    Crna: 'CRNA',
    Crnfa: 'CRNFA',
    Crni: 'CRNI',
    Crno: 'CRNO',
    Crrn: 'CRRN',
    Csc: 'CSC',
    Ctrn: 'CTRN',
    Cua: 'CUA',
    Cunp: 'CUNP',
    Curn: 'CURN',
    Cwcn: 'CWCN',
    CwcnAp: 'CWCN_AP',
    Cwocn: 'CWOCN',
    CwocnAp: 'CWOCN_AP',
    Cwon: 'CWON',
    CwonAp: 'CWON_AP',
    Dcnp: 'DCNP',
    Dnc: 'DNC',
    EnpBc: 'ENP_BC',
    Enpc: 'ENPC',
    FnpBc: 'FNP_BC',
    FnpC: 'FNP_C',
    GcnsBc: 'GCNS_BC',
    GnpBc: 'GNP_BC',
    HhcnsBc: 'HHCNS_BC',
    HnBc: 'HN_BC',
    HnbBc: 'HNB_BC',
    HwncBc: 'HWNC_BC',
    Lncc: 'LNCC',
    NcBc: 'NC_BC',
    Ncsn: 'NCSN',
    NeBc: 'NE_BC',
    NeaBc: 'NEA_BC',
    NnpBc: 'NNP_BC',
    NpC: 'NP_C',
    Nrp: 'NRP',
    Ocn: 'OCN',
    OcnsC: 'OCNS_C',
    Onc: 'ONC',
    OnpC: 'ONP_C',
    Pals: 'PALS',
    Pccn: 'PCCN',
    PccnK: 'PCCN_K',
    PcnsBc: 'PCNS_BC',
    PhcnsBc: 'PHCNS_BC',
    Phms: 'PHMS',
    PhnaBc: 'PHNA_BC',
    PmhcnsBc: 'PMHCNS_BC',
    PmhnpBc: 'PMHNP_BC',
    PpcnpBc: 'PPCNP_BC',
    RnBc: 'RN_BC',
    RncLrn: 'RNC_LRN',
    RncMnn: 'RNC_MNN',
    RncNic: 'RNC_NIC',
    RncOb: 'RNC_OB',
    SaneA: 'SANE_A',
    SaneP: 'SANE_P',
    Scrn: 'SCRN',
    SnpBc: 'SNP_BC',
    Stable: 'STABLE',
    Tcrn: 'TCRN',
    Tncc: 'TNCC',
    WhnpBc: 'WHNP_BC'
};
/**
 * Check if a given object implements the DocumentAuditClaimedCertificationDto interface.
 */
function instanceOfDocumentAuditClaimedCertificationDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('holderName' in value) || value['holderName'] === undefined)
        return false;
    if (!('expiration' in value) || value['expiration'] === undefined)
        return false;
    return true;
}
function DocumentAuditClaimedCertificationDtoFromJSON(json) {
    return DocumentAuditClaimedCertificationDtoFromJSONTyped(json, false);
}
function DocumentAuditClaimedCertificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'holderName': json['holderName'],
        'expiration': json['expiration'],
    };
}
function DocumentAuditClaimedCertificationDtoToJSON(json) {
    return DocumentAuditClaimedCertificationDtoToJSONTyped(json, false);
}
function DocumentAuditClaimedCertificationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'holderName': value['holderName'],
        'expiration': value['expiration'],
    };
}
//# sourceMappingURL=DocumentAuditClaimedCertificationDto.js.map